module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "menu"
    }
  }, [_c('login'), _vm._v(" "), _c('signup')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93d76e76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Menu.vue
// module id = 278
// module chunks = 0